const CaptchaBox = ({ mathCaptcha, captcha, setCaptcha, generateMathCaptcha }) => (
    <div className="capthaFeildsSection d-flex">
        <div className="mathCaptcha">{mathCaptcha.question} = ?</div>

        <input
            type="text"
            placeholder="Enter answer"
            className="form-control new_padding"
            value={captcha}
            onChange={(e) => setCaptcha(e.target.value)}
        />

        <button
            type="button"
            className="refreshCaptchaImg customHoverBtn"
            onClick={() => { generateMathCaptcha(); setCaptcha(""); }}
        >
            <i className="fa fa-refresh" aria-hidden="true"></i>
        </button>
    </div>
);

export default CaptchaBox;